import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
}), 'ClassRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ClassRounded.js
// module id = 2805
// module chunks = 2